import { createStore } from 'vuex';

export default createStore({
  state: {
    loggedInGoogle: false,
    userGoogle: null,
    status: 1,
    exchange: "NSE",
    organization: null,
  },
  
  getters: {
    isAuthenticated: state => !!state.userGoogle,
    currentUser: state => state.userGoogle,
    status: state => state.status,
    exchange: state => state.exchange,
    organization: state => state.organization,
  },
  
  mutations: {
    setLoggedInGoogle(state, status) {
      state.loggedInGoogle = status;
    },
    
    setUserGoogle(state, user) {
      state.userGoogle = user;
    },
    setStatus(state, status){
      state.status = status
    },
    setExchange(state, exchange) {
      state.exchange = exchange;
    },
    setOrganization(state, organization) {
      state.organization = organization;
    },
  },
  
  actions: {
    login({ commit }, userData) {
      commit('setLoggedInGoogle', true);
      if (userData.status !== undefined) {
        commit('setStatus', userData.status);
        //delete userData.status;
      }
      commit('setUserGoogle', userData);
    },
    logout({ commit }) {
      commit('setLoggedInGoogle', false);
      commit('setUserGoogle', null);
      commit('setStatus', 1);
    },
    updateExchange({ commit }, exchange) {
      commit('setExchange', exchange);
    },
    updateOrganization({ commit }, organization) {
      commit('setOrganization', organization);
    }  
  },
});